import { render, staticRenderFns } from "./areaReportDetail.vue?vue&type=template&id=6192f93a&scoped=true&"
import script from "./areaReportDetail.vue?vue&type=script&lang=js&"
export * from "./areaReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./areaReportDetail.vue?vue&type=style&index=0&id=6192f93a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6192f93a",
  null
  
)

export default component.exports